import { createI18n } from 'vue-i18n';
import { setLocale } from 'yup';

const localeLoaders = {
  fa: () => import('./fa.json'),
};

const getPreferredLocale = () => {
  return 'fa';
};

export const i18n = createI18n({
  legacy: false,
  locale: getPreferredLocale(),
  fallbackLocale: 'fa',
  messages: {},
});

export const loadLocale = async (locale: keyof typeof localeLoaders) => {
  const messages = await localeLoaders[locale]();

  i18n.global.setLocaleMessage(locale, messages.default);
};

setLocale({
  mixed: {
    default: ({ label }) => i18n.global.t('validation-messages.mixed.default', { field: label }),
    required: ({ label }) => i18n.global.t('validation-messages.mixed.required', { field: label }),
    oneOf: ({ label, values }) =>
      i18n.global.t('validation-messages.mixed.one-of', {
        field: label,
        values,
      }),
    notOneOf: ({ label, values }) =>
      i18n.global.t('validation-messages.mixed.not-one-of', {
        field: label,
        values,
      }),
  },
  string: {
    length: ({ label, length }) =>
      i18n.global.t('validation-messages.string.length', {
        field: label,
        length,
      }),
    min: ({ label, min }) => i18n.global.t('validation-messages.string.min', { field: label, min }),
    max: ({ label, max }) => i18n.global.t('validation-messages.string.max', { field: label, max }),
    email: ({ label }) => i18n.global.t('validation-messages.string.email', { field: label }),
    url: ({ label }) => i18n.global.t('validation-messages.string.url', { field: label }),
    trim: ({ label }) => i18n.global.t('validation-messages.string.trim', { field: label }),
    lowercase: ({ label }) => i18n.global.t('validation-messages.string.lowercase', { field: label }),
    uppercase: ({ label }) => i18n.global.t('validation-messages.string.uppercase', { field: label }),
  },
  number: {
    min: ({ label, min }) => i18n.global.t('validation-messages.number.min', { field: label, min }),
    max: ({ label, max }) => i18n.global.t('validation-messages.number.max', { field: label, max }),
    lessThan: ({ label, less }) =>
      i18n.global.t('validation-messages.number.less-than', {
        field: label,
        less,
      }),
    moreThan: ({ label, more }) =>
      i18n.global.t('validation-messages.number.more-than', {
        field: label,
        more,
      }),
    positive: ({ label }) => i18n.global.t('validation-messages.number.positive', { field: label }),
    negative: ({ label }) => i18n.global.t('validation-messages.number.negative', { field: label }),
    integer: ({ label }) => i18n.global.t('validation-messages.number.integer', { field: label }),
  },
  array: {
    min: ({ label, min }) => i18n.global.t('validation-messages.array.min', { field: label, min }),
    max: ({ label, max }) => i18n.global.t('validation-messages.array.max', { field: label, max }),
  },
  date: {
    min: ({ label, min }) => i18n.global.t('validation-messages.date.min', { field: label, min }),
    max: ({ label, max }) => i18n.global.t('validation-messages.date.max', { field: label, max }),
  },
});
